module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/865309ebdabe1a08b6ae2a7fa8bc4cdf.png";